import i18n from "@/i18n";

const routes = {
  path: "/booking",
  name: "Booking",
  component: () =>
    import(/* webpackChunkName: "booking" */ "@/views/booking/Main"),
  children: [
    {
      path: "day",
      alias: "",
      name: "BookingDay",
      component: () =>
        import(/* webpackChunkName: "booking" */ "@/views/booking/Day"),
      prop: true,
      meta: {
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.booking.booking_date"),
        step: [
          i18n.t("menu.booking.booking"),
          i18n.t("page.booking.booking_date"),
        ],
        menu_num: 2,
        sub_menu_num: 21,
        location: "/booking/day",
      },
    },
    {
      path: "table",
      name: "BookingTable",
      component: () =>
        import(/* webpackChunkName: "booking" */ "@/views/booking/Table"),
      prop: true,
      meta: {
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.booking.booking_list"),
        step: [
          i18n.t("menu.booking.booking"),
          i18n.t("page.booking.booking_list"),
        ],
        menu_num: 2,
        sub_menu_num: 22,
        location: "/booking/table",
      },
    },
  ],
};

export default routes;
